import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { ListingCard } from "@/components/ListingCard";

export const NewLaunchPreviewSection = ({ buildBrandedPath, listings = [] }) => {
  const newLaunchListings = listings.filter((listing) => listing.category === "new_launch").slice(0, 3);

  if (!newLaunchListings.length) return null;

  return (
    <section className="section-shell pt-8" data-testid="homepage-new-launches-section">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#8b6d16]">New Launches Preview</p>
          <h2 className="mt-3 text-4xl font-semibold leading-tight text-[#001935] md:text-5xl" data-testid="homepage-new-launches-heading">
            New Launch opportunities worth watching now.
          </h2>
          <p className="mt-4 max-w-3xl text-sm leading-8 text-[#42566f] md:text-base" data-testid="homepage-new-launches-copy">
            Explore selected projects with launch momentum, showflat activity, and clearer next-step guidance.
          </p>
        </div>

        <Link className="outline-button" data-testid="homepage-new-launches-button" to={buildBrandedPath("/new-launches")}>
          Explore New Launches <ArrowRight className="ml-2 h-4 w-4" />
        </Link>
      </div>

      <div className="mt-8 grid gap-6 lg:grid-cols-3">
        {newLaunchListings.map((listing) => (
          <ListingCard key={listing.id} listing={listing} />
        ))}
      </div>
    </section>
  );
};